import { FC } from 'react';
import { Tag } from '../../../../../lib/model/Tag';
import { DeleteOutlined } from '@ant-design/icons';

interface IProps {
	items: Tag[];
	remove_tag: (item: Tag) => void;
	get_tag_type_title: (tag: Tag) => string;
}

export const SelectedTagsForVids: FC<IProps> = ({ items, remove_tag, get_tag_type_title }) => {
	return (
		<div className='mt-4 w-full'>
			<Title {...{ title: 'Itens Selecionados' }} />
			<Items {...{ items, remove_tag, get_tag_type_title }} />
		</div>
	);
};

interface ITitle {
	title: string;
}

const Title: FC<ITitle> = ({ title }) => {
	return <h1 className='font-semibold mb-2'>{title}</h1>;
};

const Items: FC<IProps> = ({ items, remove_tag, get_tag_type_title }) => {
	const sortedItems = [...items].sort((a, b) => get_tag_type_title(a).localeCompare(get_tag_type_title(b)));

	return (
		<table className='table-layout: auto;'>
			{sortedItems.map((content: Tag) => {
				if (content.id.includes('video')) {
					return (
						<tbody key={content.id} className='ant-table-tbody'>
							<tr data-row-key='1' className='ant-table-row ant-table-row-level-0 '>
								<td className='ant-table-cell'>{get_tag_type_title(content)}</td>
								<td>
									<DeleteOutlined style={{ color: '#ff0000' }} onClick={() => remove_tag(content)} />
								</td>
							</tr>
						</tbody>
					);
				}
			})}
		</table>
	);
};
